module.exports = __webpack_public_path__ + "81f5815cbc196d0458ea90563d1b209a.png";